import { Injectable } from "@angular/core";
import { RestService } from "../../core/rest.service";
import { GridResponse } from "./grid.model";

@Injectable()
export class GridRest {
    constructor(private http: RestService) { }

    public getGridData(dataRestPath: string, request: any) {
        return this.http.post<GridResponse>(dataRestPath, request);
    }

    public saveColumnsSettings(restPath: string, settingsJson: string) {
        let settingsData = {restPath: restPath, settingsJson: settingsJson}
        return this.http.post(`api/gridsettings/saveColumnsSettings`, settingsData);
    }
}